<template>
  <div class="bu-toast-container">
    <transition-group name="toast-list" tag="div" class="toast-wrapper">
      <div 
        v-for="toast in toasts" 
        :key="toast.id" 
        :class="['bu-toast', `bu-toast-${toast.type}`]"
        @click="removeToast(toast.id)"
      >
        <div class="bu-toast-icon">
          <i v-if="toast.type === 'success'" class="fa fa-check-circle"></i>
          <i v-else-if="toast.type === 'error'" class="fa fa-exclamation-circle"></i>
          <i v-else-if="toast.type === 'warning'" class="fa fa-exclamation-triangle"></i>
          <i v-else class="fa fa-info-circle"></i>
        </div>
        <div class="bu-toast-content">
          <strong v-if="toast.title" class="bu-toast-title">{{ toast.title }}</strong>
          <span class="bu-toast-message">{{ toast.message }}</span>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script setup>
import { useToast } from '@/composables/useToast'

const { toasts, removeToast } = useToast()
</script>

<style scoped>
.bu-toast-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  pointer-events: none;
  width: 100%;
  max-width: 320px;
}

.toast-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 20px;
}

.bu-toast {
  background: rgba(10, 12, 18, 0.85);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 12px;
  padding: 12px 16px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);
  pointer-events: auto;
  cursor: pointer;
  font-family: 'Poppins', sans-serif;
}

.bu-toast-success .bu-toast-icon { color: #4ade80; }
.bu-toast-error .bu-toast-icon { color: #f87171; }
.bu-toast-warning .bu-toast-icon { color: #fbbf24; }
.bu-toast-info .bu-toast-icon { color: #60a5fa; }

.bu-toast-icon {
  font-size: 1.25rem;
  margin-top: 2px;
}

.bu-toast-content {
  display: flex;
  flex-direction: column;
}

.bu-toast-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: #f8fafc;
}

.bu-toast-message {
  font-size: 0.8rem;
  color: #cbd5e1;
}

/* Transitions */
.toast-list-enter-active, .toast-list-leave-active { transition: all 0.3s ease; }
.toast-list-enter-from { opacity: 0; transform: translateX(30px); }
.toast-list-leave-to { opacity: 0; transform: translateX(30px); }
</style>